<template>
    <div class="file-list">
        <btn-wrapper
            @click="openLink()"
            :params="{
                class: 'link file-list__link',
                type: 'link',
                path: `#`,
                isSlotIsset: true
            }"
        >
            <div class="file-list__icon">
                <svg class="icon">
                    <use xlink:href="/img/sprites/icons-sprite.svg#icon-data"></use>
                </svg>
            </div>
            <div class="file-list__col">
                <div class="file-list__name">{{ props.item.filename }}</div>
                <div class="file-list__format">{{ props.item.extension }}</div>
            </div>
        </btn-wrapper>
    </div>
</template>

<script setup>
import {defineProps} from "vue";

const props = defineProps(['item'])
const openLink = () => {
    window.open(props.item.url)
}
</script>

<style lang="scss" scoped>
@import '../scss/file-list.scss';
</style>
